export default __webpack_public_path__ + "static/media/soldier_02.75264bf7.jpeg";